import React from 'react';
import { InfoPopupStore } from '../../_flux/stores/info_popup_store';
import { InfoPopup } from '../../_flux/components/info_popup/info_popup';
import { hideAction } from '../../_flux/actions/info_popup_actions';
import { handleView } from '../handle_view';
import { onBodyButtonClick } from './on_body_button_click';
const stores = {
    state: InfoPopupStore
};

const render = ({ state }, options) => (
    <InfoPopup
        visible={state.visible}
        dispatcher={state.dispatcher}
        onCloseClick={hideAction}
        headerContent={state.headerContent}
        bodyContent={state.bodyContent}
        bodyButtonText={state.bodyButtonText}
        bodyButtonOnClick={onBodyButtonClick}
        bodyUpperImagePath={state.bodyUpperImagePath}
        bodyLowerImagePath={state.bodyLowerImagePath}
        showCloseButton={state.showCloseButton}
    />
);

export const init = (container, options) =>
    handleView(stores, render, options, container);
